/**
 * Created by Ning Jiang on 2022-04-01.
 */

import {DDay} from "../DDay";
import {DDayGameConfig} from "../DDayGameConfig";

export class BelowStakeWinRestriction {

    public static getBuyFeaturePrice(): number {
        let betLevel = DDay.apiPlugin.freeBets.hasFreeBets() ? DDay.apiPlugin.freeBets.getBet() : DDay.apiPlugin.betLevel.getLevel();
        let price: number = DDay.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (DDay.model.data.wasFeatureBuy || this.isBoostedBet()) {
            for (let index = 0; index < DDay.model.initData.featureBuyTimesBetValue.length; index++) {
                if (DDay.model.initData.featureBuyTimesBetValue[index].name === DDay.model.buyFeatureName) {
                    price *= DDay.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    public static isBoostedBet(): boolean {
        const activeFeature = DDay.apiPlugin.betFeatureController.getActiveBetFeature();
        if (activeFeature) {
            return activeFeature.name === "BOOSTED_BET";
        }
        return false;
    }

    // https://github.com/nolimitcity/nolimit-slot-launcher/issues/397
    public static isWinBelowStake(): boolean {
        return DDay.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (DDay.model.data.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }

    public static isWinBelowPlayedBetValue(): boolean {
        if (!DDay.apiPlugin.gameClientConfiguration.belowStakeWinRestriction) {
            return false;
        }

        let playedBetValue = DDay.model.gameData?.playedBetValue || parseFloat(DDay.apiPlugin.freeBets.hasFreeBets() ? DDay.apiPlugin.freeBets.getBet() : DDay.apiPlugin.betLevel.getLevel());
        if (this.isBoostedBet()) {
            playedBetValue *= 1.3;
        }
        return (DDay.model.gameData.totalSpinWinnings / playedBetValue) <= 1;
    }

    public static reset(): void {
        DDay.model.buyFeatureName = "";
    }
}
